export default __webpack_public_path__ + "static/media/Brakes.0bbf4c1e.jpg";